import {Init} from '@/core/Init'
import {Setup} from '@/core/main/Setup'
import {APP_EVT} from '@/core/config/constants'
import {Attachable} from '@/core/items/base/Attachable'
import {Params} from '@/core/services/Params';

import * as svgjs from '@svgdotjs/svg.js'

class Debug {

	static msg = '';

	private clickclipVisible: boolean;
	private sboxVisible: boolean;
	private yboxVisible: boolean;
	private xboxVisible: boolean;
	private tboxVisible: boolean;
	private dimensionsVisible: boolean;

	constructor() {

		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_PANEL, this.toggleDebugOptions);
		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_CLICKCLIP, this.toggleDebugClickclip);
		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_SBOX, this.toggleCollisionBounds);

		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_YBOX, this.toggleDebugBounds);
		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_XBOX, this.toggleDebugNeighbors);
		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_TBOX, this.toggleDebugHitpointTargets);
		Init.emitter.on(APP_EVT.TOGGLE_DEBUG_DIMENSIONS, this.toggleDebugDimensions);
		Init.emitter.on(APP_EVT.CLICKCLIP_MOUSE_OVER, this.clickclipMouseOver);

		this.clickclipVisible = false;
		this.sboxVisible = false;
		this.yboxVisible = false;
		this.xboxVisible = false;
		this.tboxVisible = false;
		this.dimensionsVisible = false;

	}

	toggleDebugOptions = (): void => {

		if (Init.debug_active === true) {

			$('#tool-debug').animate({top: 0}, 100, function () {
				$(this).hide();
			});

		} else {

			$('#tool-debug').show().animate({top: Setup.header_height}, 100);

		}

		Init.debug_active = !Init.debug_active;

	};

	/**
	 * toggle the visibility of the debug panel
	 */
	showDebugOptions = (): void => {

		Init.debug_active = !Init.debug_active;

		if (Init.debug_active === true) {

			$('#btn-debug').addClass('btn-active');

			$('#modal-debug-options').show();
			$('#modal-debug-options').css({zIndex: 5000, position: 'absolute', right: 10, bottom: 10});

		} else {

			this.toggleDebugClickclip(false);
			this.toggleDebugBounds(false);

			$('#btn-debug').removeClass('btn-active');

			$('#modal-debug-options').hide();

		}
	};


	/**
	 * set the action that occurs when the user clicks on the item.
	 * set the item as our current 'active item'.
	 * bring the item to the front of the SVG.
	 *
	 * @param item
	 */
	clickclipMouseOver = (item: Attachable): void => {

		if (Init.debug_active === true) {

			let msg: string = '';

			$.each(item.debug, function (key: string, val) {

					switch (key) {

						case 'prnt':
						case 'chld':

							msg += key + ': <br>';

							$.each(val, function (a: string, row) {
								$.each(row, function (b: string, itm) {
									msg += ' &nbsp; &nbsp; ' + a + ': ' + b + ': ' + itm.itemName + '<br>';
								});
							});
							break;

						case 'panels':

							msg += key + ': <br>';

							$.each(val, function (wall: string, row) {

								$.each(row, function (location: string, itm_id) {

									msg += ' &nbsp; &nbsp; ' + wall + ': ' + location + ': ' + Params.getItem(itm_id).item_name + '<br>';
								});
							});
							break;

						case 'options':
						case 'transform':
							//case 'decks':
							msg += key + ': <br>';
							$.each(val, function (k: string, r: string) {
								msg += ' &nbsp; ' + k + ': ' + r + '<br>';
							});
							break;

						case 'fences':

							msg += key + ': <br>';
							$.each(val, function (k: string, row: any) {
								$.each(row, function (i: string, j: string) {
									msg += ' &nbsp; &nbsp; ' + k + ': ' + i + ': ' + j + '<br>';
								});
							});
							break;

						case 'bays':
							// active: boolean;
							// posts: string[];
							// upper_brace: number;
							// lower_brace: boolean;
							// braces: number[]
							// extender: boolean
							msg += key + ': <br>';
							for (let [bay, row] of val) {
								msg += ' &nbsp; &nbsp; ' + bay
									+ ' ' + row.active
									+ ' ' + row.braces
									+ ' ' + row.upper_brace
									+ ' ' + row.extender
									+ ' ' + row.cleats_single
									+ ' ' + row.cleats_double + '<br>';
							};
							break;

						case 'posts':
							msg += key + ': <br>';
							for (let [id, row] of val) {
								msg += ' &nbsp; &nbsp; ' + id + ': ' + row.active + ': ' + row.height + '<br>';
							}
							break;

						default:
							msg += key + ': ' + val + '<br>';
							break;
					}

				}
			);

			$('.debug #msg-debug').html(msg);
		}
	};

	toggleDebugDimensions = (state?: boolean): void => {

		if (this.dimensionsVisible === false) {

			$('.no-size').hide();

			let b: svgjs.Box = svgjs.SVG('#svg-stage').bbox();

			$('#dbox').show();

			svgjs.SVG('#dbox').size(b.width, b.height).move(b.x, b.y);

			$('.no-size').show();

		} else {

			$('#dbox').hide();

		}

		this.dimensionsVisible = (state != undefined) ? state : (!this.dimensionsVisible);

	}


	/**
	 * toggle the visibility of each item's clickclip layer for debugging
	 */
	toggleDebugClickclip = (state?: boolean): void => {

		this.clickclipVisible = (state != undefined) ? state : (!this.clickclipVisible);

		//console.log('toggleDebugClickclip', this.clickclipVisible, state);

		if (this.clickclipVisible == true) {

			$('#svg-stage .clickclip').css('opacity', 0.25);

		} else {

			$('#svg-stage .clickclip').css('opacity', 0);

		}
	};


	/**
	 * toggle the visibility of each item's ybox layer for debugging
	 */
	toggleDebugBounds = (state?: boolean): void => {

		this.yboxVisible = (state != undefined) ? state : (!this.yboxVisible);

		if (this.yboxVisible == true) {

			$('#svg-stage .ybox').css('display', 'block');

		} else {

			$('#svg-stage .ybox').css('display', 'none');

		}
	};


	/**
	 * toggle the visibility of each item's ybox layer for debugging
	 */
	toggleCollisionBounds = (state?: boolean): void => {

		this.sboxVisible = (state != undefined) ? state : (!this.sboxVisible);

		if (this.sboxVisible == true) {

			$('#svg-stage .sbox').css('display', 'block');

		} else {

			$('#svg-stage .sbox').css('display', 'none');

		}
	};
	/**
	 * toggle the visibility of each item's ybox layer for debugging
	 */
	toggleDebugHitpointTargets = (state?: boolean): void => {

		this.tboxVisible = (state != undefined) ? state : (!this.tboxVisible);

		if (this.tboxVisible == true) {

			$('#svg-stage .tbox').css('display', 'block');

		} else {

			$('#svg-stage .tbox').css('display', 'none');

		}
	};

	/**
	 * toggle the visibility of each item's ybox layer for debugging
	 */
	toggleDebugNeighbors = (state?: boolean): void => {

		this.xboxVisible = (state != undefined) ? state : (!this.xboxVisible);

		if (this.xboxVisible == true) {

			$('#svg-stage .xbox').css('display', 'block');

		} else {

			$('#svg-stage .xbox').css('display', 'none');

		}
	};

	static addToList(data): void {

		Debug.msg += '<tr><td>' + data.className + '</td><td>' + data.x + '</td><td>' + data.y + '</td><td>' + data.r + '</td></tr>';

	}


	static publish(): void {

		Debug.msg = '<table>' + Debug.msg + '</table>';


		$('.debug #msg').html(Debug.msg);

	}


	static clear(): void {

		Debug.msg = '';

		$('.debug #msg').html('');

	}


}

export {Debug};

